import { render } from "./paymentMethods.vue?vue&type=template&id=82fafce6"
import script from "./paymentMethods.vue?vue&type=script&lang=js"
export * from "./paymentMethods.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/clients.printpigeons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__